import React from 'react'
import { arrayOf, shape, string } from 'prop-types'
import { TextBox } from '../../atoms'
import { FeatureList } from '../../molecules'

/**
 * simple feature list with additional textbox
 * @param getToKnow
 * @returns {JSX.Element}
 * @constructor
 */
const GetToKnow = ({ getToKnow }) => {
  const { items, additionalInfo } = getToKnow
  return (
    <>
      <FeatureList
        itemList={ [{ title: '', items }] }
        listClass='list-checkmark'
      />
      {additionalInfo !== null && additionalInfo !== '' && (
        <TextBox title={ '' }>{additionalInfo}</TextBox>
      )}
    </>
  )
}

GetToKnow.propTypes = {
  getToKnow: shape({
    items: arrayOf(string),
    additionalInfo: string,
  }),
}

export default GetToKnow
